<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <!-- <el-form-item label="订单号">
              <el-input v-model="searchCondition.outer_trade_no" placeholder="输入订单号" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <!-- <el-form-item label="备注名称">
              <el-input v-model="searchCondition.remark" placeholder="输入备注名称" clearable></el-input>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row style="height: 36px">
          <ScreeCompany @ScreeCompany="ScreeCompany"/>
          <div class="table-right">
            <el-select v-model="value" placeholder="请选择导出类型" @change="selectData" class="select-box" size="medium">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button :loading="downloadLoading" style="margin:0 0 20px 20px;" type="primary" size="medium" icon="el-icon-document" @click="handleDownload">
              导出
            </el-button>
          </div>
        </el-row>
        <ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            slot="first-column"
            align="center"
            label="公司名称">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.outer_trade_no" placement="top">
                <div>{{ scope.row.company_name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            prop="money"
            align="center"
            sortable
            label="充值金额">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag type="warning">¥ {{scope.row.money}}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            prop="tax_money"
            sortable
            label="服务费">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag type="warning">¥ {{scope.row.tax_money}}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            prop="is_collect"
            sortable
            label="是否收取服务费">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag v-if="scope.row.is_collect == '11'" type="success">成功</el-tag>
                <el-tag v-else type="danger">失败</el-tag>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-if="buttonType=='text'"
            width="80"
            label="操作">
            <template slot-scope="scope">
              <span>
                <el-button size="mini" type="default" v-if="userPermissions.indexOf('tradeRecharge_view') != -1"  @click="viewButton(scope.row.id)">详情</el-button>
              </span>
            </template>
          </el-table-column> -->
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import ScreeCompany from '@/components/ScreeCompany.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
    ScreeCompany
  },
  data() {
    return {
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      downloadLoading: false,
      options: [{
          value: 'xlsx',
          label: 'xlsx'
        }, {
          value: 'csv',
          label: 'csv'
        }, {
          value: 'txt',
          label: 'txt'
        }
      ],
      value: 'xlsx',
      //导出表格类型
      bookType: 'xlsx',
      loadingStaus: true,
      columns: [
        // {
        //   title: '公司名称',
        //   value: 'payer_card_name',
        //   // header_align: 'center',
        //   // align: 'center',
        // },
        // {
        //   title: '金额',
        //   // width: 200,
        //   value: [
        //     {label:'服务费：',value:'tax_money'},
        //     {label:'充值金额：',value:'money'},
        //   ],
        //   // header_align: 'center',
        //   // align: 'center',
        // },
        {
          title: '收款方',
          width: 300,
          value: [
            {label:'付款户名：',value:'payer_card_name'},
            {label:'付款账号：',value:'payer_card_no'},
            {label:'收款户名：',value:'payee_card_name'},
            {label:'收款帐号：',value:'payee_card_no'},
            {label:'银行渠道：',value:'pid'}
          ],
          // header_align: 'center',
        /*   align: 'center', */
        },
        {
          title: '备注',
          value: 'payer_remark',
          header_align: 'center',
          align: 'center',
         /*  width: 250 */
        },

        {
          title: '创建时间',
          value: 'created_at',
          header_align: 'center',
          align: 'center',
        }
      ],
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        // direction: 'right',
        title: '',
        width_height: '640px',
        show_footer:false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList:[],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: '标题',
          value: 'title',
        }
      ],
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentTradeRechargeId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    ScreeCompany(v, name) {
      if(name == 'company') {
        if (v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }else if(name == 'settlement') {
        if (v) {
          this.searchCondition.channel_account = v
        } else {
          delete this.searchCondition.channel_account
        }
        this.init('search')
      }
    },
    // 搜索
    searchButton() {
      this.init('search')
    },
    selectData(e) {
      this.bookType = e;
    },
     //导出
    async handleDownload() {
      this.isExport = true;
      this.downloadLoading = true
      let list = await this.init('export')
      import('@/excel/Export2Excel').then( excel => {
        const tHeader = ['公司名称', '充值金额', '服务费', '付款户名', '付款账号', '收款户名', '收款帐号', '备注', '创建时间'];
        const data = this.formatJson(list)
        const time = new Date().getTime() + Math.random() * 1000
        let filename = `账户充值记录${time}`
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType //Optional
        })
        this.downloadLoading = false;
      })
    },
    formatJson(jsonData) {
      return jsonData.map(v =>{
        let {
          company_name,
          money,
          tax_money,
          payer_card_name,
          payer_card_no,
          payee_card_name,
          payee_card_no,
          payer_remark,
          created_at
        } = v
        return [company_name, money, tax_money, payer_card_name, payer_card_no, payee_card_name, payee_card_no, payer_remark, created_at]
      })
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    // 响应添加按钮
    async addButton() {
      this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id) {
      this.$router.push(this.$route.path+'/'+id+'/view')
    },
    // 响应编辑按钮
    async editButton(id) {
      this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteMixinRecharge(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.init('del')
        })
      } else {
        this.$message.error(info)
      }

    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.outer_trade_no) {
        condition.outer_trade_no = this.searchCondition.outer_trade_no
      }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        }
      }
      if (this.searchCondition.company_id || this.searchCondition.channel_account) {
        condition.company_id = this.searchCondition.company_id
        condition.channel_account = this.searchCondition.channel_account
      }
      return condition
    },
     //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 初始化
    async init(type) {
      if (type) {
        this.mxResetPage()
      }
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if(type == 'export') {
        pagingInfo.page_size = 50000
      } else {
        this.loadingStaus=true
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages} = await this.$api.getAdminTradeRechargeList(searchCondition)
      if(type == 'export') {
        return list
      } else {
        this.dataList=list
        this.dataList.forEach(item => {
          switch(item.pid) {
            case 'ws': item.pid = '网商银行'; break;
            case 'yinglin': item.pid = '银灵科技'; break;
            default: break;
          }
        })
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus=false
      }
    },
    keyupSubmit(){
      document.onkeydown = e => {
        console.log(e)
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },
  created() {
    this.keyupSubmit()
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .table-right
    float: right;
  .select-box
    width: 100px
  .returnBtn
    position: relative
    top: 10px
    float: right
  .el-tag
    font-size 14px
    line-height 38px
    height 38px
  .money
    font-weight bold
  .el-tag + .el-tag
    margin-left 10px
  // .table-search
  //   height: 36px
</style>
